import { kea } from 'kea'
import PropTypes from "prop-types";
import {filter, get, map} from "lodash";
import { put } from 'redux-saga/effects'

import { Carts } from "@gratify-eu/entities"
import entities from '~/entities'

export default kea({
  path: () => ['scenes', 'discount'],

  actions: ({ constants }) => ({
    applyCode: (code) => ({code}),
    removeCode: (code) => ({code})
  }),

  reducers: ({ actions, constants }) => ({
    applyingCode: [false, PropTypes.bool, {
      [Carts.actions.applyCode.request]: () => (true),
      [Carts.actions.applyCode.success]: () => (false),
      [Carts.actions.applyCode.failure]: () => (false),
    }],
    discountError: [null, PropTypes.string, {
      [Carts.actions.applyCode.failure]: (_, payload) => {
        console.log('payload', payload);
        return get(payload, 'message.code', []).join(', ')
      },
      [actions.applyCode]: () => (null)
    }],
  }),

  selectors: ({ constants, selectors }) => ({
    activeCart: [
      () => [
        entities.selectors.activeCart
      ], (activeCart) => {
        return activeCart
      },
      PropTypes.object
    ],
    appliedCodes: [
      () => [
        entities.selectors.activeCart
      ], (activeCart) => {
        if (activeCart && activeCart.discounts) {
          const codeDiscounts = filter(activeCart.discounts, 'code');
          if(codeDiscounts && codeDiscounts.length > 0) {
            return map(codeDiscounts, 'code');
          }
        }
        return null;
      },
      PropTypes.array
    ],
    showDiscountInput: [
      () => [
        entities.selectors.activeShop
      ], (activeShop) => {
        return get(activeShop, 'checkout_settings.discount_visible', false);
      },
      PropTypes.bool
    ],
  }),

  takeEvery: ({ actions, workers }) => ({
    [actions.applyCode]: workers.applyCode,
    [actions.removeCode]: workers.removeCode,
  }),

  workers: {
    * applyCode(action) {
      const { code } = action.payload || {};

      const activeCart = yield this.get('activeCart');

      if(activeCart) {
        yield put(Carts.actions.applyCode.request(activeCart, code))
      }
    },
    * removeCode(action) {
      const { code } = action.payload || {};

      const activeCart = yield this.get('activeCart');

      if(activeCart) {
        yield put(Carts.actions.removeCode.request(activeCart, code))
      }
    },
  }
})
